export const mockDashboardData = {
  metrics: {
    totalProducts: 17,
    verificationsToday: 89873,
    successRate: 98.3,
    activeNFTs: 342,
    registeredUsers: 15689,
    newUsersToday: 235
  },

  charts: {
    verificationTrends: [
      { date: '2025-01-08', verifications: 45 },
      { date: '2025-01-09', verifications: 67 },
      { date: '2025-01-10', verifications: 52 },
      { date: '2025-01-11', verifications: 78 },
      { date: '2025-01-12', verifications: 61 },
      { date: '2025-01-13', verifications: 84 },
      { date: '2025-01-14', verifications: 72 },
      { date: '2025-01-15', verifications: 89 }
    ],

    geographic: [
      { country: 'United States', verifications: 1247, percentage: 32.1 },
      { country: 'United Kingdom', verifications: 892, percentage: 23.0 },
      { country: 'France', verifications: 634, percentage: 16.4 },
      { country: 'Germany', verifications: 423, percentage: 10.9 },
      { country: 'Australia', verifications: 298, percentage: 7.7 },
      { country: 'Canada', verifications: 234, percentage: 6.0 },
      { country: 'Italy', verifications: 147, percentage: 3.8 }
    ],

    userEngagement: [
      { stage: 'Scans', count: 2847, percentage: 100 },
      { stage: 'App Downloads', count: 1423, percentage: 50 },
      { stage: 'Account Creation', count: 852, percentage: 30 },
      { stage: 'Profile Complete', count: 568, percentage: 20 }
    ]
  },

  activities: [
    {
      id: 1,
      type: 'verification',
      message: 'Wine verified: Château Margaux 2018',
      timestamp: '2025-01-15T10:30:00Z',
      location: 'New York, USA'
    },
    {
      id: 2,
      type: 'user_registration',
      message: 'New user registered: john.doe@email.com',
      timestamp: '2025-01-15T10:25:00Z',
      location: 'London, UK'
    },
    {
      id: 3,
      type: 'product_added',
      message: 'New product added: Dom Pérignon 2019',
      timestamp: '2025-01-15T10:20:00Z',
      location: 'Paris, France'
    },
    {
      id: 4,
      type: 'verification',
      message: 'Wine verified: Opus One 2020',
      timestamp: '2025-01-15T10:15:00Z',
      location: 'California, USA'
    },
    {
      id: 5,
      type: 'nft_minted',
      message: 'NFT minted for batch: BRG-2024-001',
      timestamp: '2025-01-15T10:10:00Z',
      location: 'Bordeaux, France'
    },
    {
      id: 6,
      type: 'user_registration',
      message: 'New user registered: alice.smith@email.com',
      timestamp: '2025-01-15T10:05:00Z',
      location: 'Sydney, Australia'
    }
  ],

  quickActions: [
    {
      id: 'create_product',
      title: 'Create New Product',
      description: 'Add a new wine to the system',
      icon: 'AddIcon',
      route: '/provenance/create'
    },
    {
      id: 'view_verifications',
      title: 'Recent Verifications',
      description: 'View latest verification logs',
      icon: 'VerifiedUserIcon',
      route: '/verifications'
    },
    {
      id: 'upload_batch',
      title: 'Upload Batch Data',
      description: 'Import multiple products via CSV',
      icon: 'UploadIcon',
      route: '/provenance/upload'
    },
    {
      id: 'generate_report',
      title: 'Generate Reports',
      description: 'Create analytics reports',
      icon: 'AssessmentIcon',
      route: '/reports'
    }
  ]
};